import React from "react";
import { NavLink } from "react-router-dom";
import classes from "./SimilarProfileItem.module.css";
import defaultAvatar from "./images/avator.png";

const SimilarProfileItem = ({
  name,
  description,
  profileImage,
  username,
  userId,
}) => {
  return (
    <div className={`col-lg-3 col-sm-6 col-12 ${classes.itemContainer}`}>
      <div className={`d-flex ${classes.profileMainContainer}`}>
        <div className={classes.profileImageContainer}>
          <NavLink to={`/user/${username}?id=${userId}`}>
            <div
              className={`${classes.profileImage}`}
              style={{
                backgroundImage: profileImage
                  ? `url(${profileImage})`
                  : `url(${defaultAvatar})`,
              }}
            ></div>
          </NavLink>
        </div>
        <div className="d-flex align-items-center">
          <NavLink
            to={`/user/${username}?id=${userId}`}
            style={{ textDecoration: "none" }}
          >
            <p className={`m-auto ${classes.profileName}`}>{name}</p>
          </NavLink>
        </div>
      </div>
      <p className={`${classes.profileDescription}`}>{description}</p>
    </div>
  );
};

export default SimilarProfileItem;
